module.exports = __webpack_public_path__ + "img/Vanessa_Marely.45ac3a20.jpg";